import { icon, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

import { IControl } from 'mapbox-gl';
import rg4js from 'raygun4js';
import { isNil } from 'src/utils/utils';
/**
 * 
 *  TODO: This file is extracted from Intern-FE-Components. When angular upgraded to version 16, can be replaced.
 * 
 *  CustomIconControl allows addding new icon controls to map. Depends on Fortawesome.
 * 
 * @param {Function} onClickButton The desired action we want to trigger for each click. When passing the desired function,
 * remember to bind the instance of the class that instantiates CustomControl. E.g. this.onDesiredAction.bind(this)
 * @param {[IconPrefix, IconName]} Fortawesome tupple that defines the icon that will be used on the button. E.g. ['far', 'layer-group']
 * 
 * @example
 * this.map.addControl(
      new CustomControl(this.appRef, this.onDesiredAction.bind(this), ['far', 'layer-group'])
    );
 */
export class CustomIconControl implements IControl {
  _map!: mapboxgl.Map | undefined;
  _container!: HTMLDivElement;
  _selectionLayerButton!: HTMLButtonElement;

  constructor(
    private faIcon: [IconPrefix, IconName] = ['far', 'layer-group'],
    private startEventType: string,
    private onStartEventTriggerFn: any,
    private endEventType?: string,
    private onEndEventTriggerFn?: any
  ) {}

  onAdd(map: mapboxgl.Map) {
    this._map = map;

    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

    this._selectionLayerButton = document.createElement('button');
    this._selectionLayerButton.addEventListener(
      this.startEventType,
      this.onStartEventTriggerFn
    );
    this._selectionLayerButton.className = 'mapboxgl-ctrl-shrink';
    this._selectionLayerButton.setAttribute('aria-label', 'Layer selection');
    this._selectionLayerButton.setAttribute('aria-disabled', 'false');
    this._selectionLayerButton.setAttribute('type', 'button');

    if (!isNil(this.endEventType)) {
      this._selectionLayerButton.addEventListener(
        this.endEventType,
        this.onEndEventTriggerFn
      );
    }

    const iconSvg = icon({ prefix: this.faIcon[0], iconName: this.faIcon[1] });
    // ERROR MONITORIZATION
    try {
      this._selectionLayerButton.appendChild(iconSvg.node[0]);
    } catch (error) {
      rg4js('send', {
        error,
        customData: {
          prefix: this.faIcon[0],
          iconName: this.faIcon[1],
        },
      });
      throw error;
    }
    this._container.appendChild(this._selectionLayerButton);
    return this._container;
  }

  onRemove() {
    this._selectionLayerButton.removeEventListener(
      this.startEventType,
      this.onStartEventTriggerFn
    );
    if (!isNil(this.endEventType)) {
      this._selectionLayerButton.removeEventListener(
        this.endEventType,
        this.onEndEventTriggerFn
      );
    }
    this._container.parentNode!.removeChild(this._container);
    this._map = undefined;
  }
}
